export default __webpack_public_path__ + "static/media/sp-bti-boy.4aca8c2e.webp";